export default __webpack_public_path__ + "static/media/calender_img.972a8db1.svg";